import React, { useEffect } from "react";
import { UiComponents } from "@simulanisindia/ui";
import BtnLoad from "../../../components/loading/BtnLoad";
import { Country, State } from "country-state-city";
const { SimInputBar, DropdownSearch } = UiComponents;

const countriesName = Country?.getAllCountries()?.map((e) => ({ value: e.name, label: e.name }));

const CreateGroup = ({
  loading,
  error,
  groupDetails,
  setGroupDetails,
  channelList,
  tagsList,
  handleCancelClicked,
  handleDebounceCreate,
  disable=false
}) => {

  const handleSaveAddress = (field, value) => {
    setGroupDetails((pre) => ({ ...pre, address: { ...pre.address, [field]: value } }));
  };

  const handleSaveIndustryType = (field, value) => {
    setGroupDetails((pre) => ({ ...pre, [field]: value }));
  };

  const handleSelectChannel = (item) => {
     setGroupDetails((pre) => ({ ...pre, channel: item.value }));
  };

  return (
    <>
      <div className="input-section">
        <div className="row section-data">
          <h6>
            Organization Details
            <div>
              <div className="save-cancel">
                <span className="action-icon-btn" onClick={handleCancelClicked}>
                  Cancel
                </span>
                {loading ? (
                  <span className="action-icon-btn save">
                    {" "}
                    <BtnLoad />{" "}
                  </span>
                ) : (
                  <span className="action-icon-btn save" onClick={handleDebounceCreate}>
                    Save
                  </span>
                )}
              </div>
              <p className="validate-error">{error}</p>
            </div>
          </h6>

          {/* <div className="col-md-12 mt-3">
                        <div className="sim-logo-upload">
                            <span className="image-here-wrapper">
                                <span className="image-here">
                                    <img
                                        src={"https://cdn.simulanis.io/sso/logos/default_simulanis.png"}
                                        referrerPolicy="no-referrer"
                                    />
                                </span>
                            </span>
                            <div className="image-details">
                                <label htmlFor="file-input" className="upload-btn">
                                    Upload Logo
                                </label>
                                <p className="small-info">
                                    500 * 500px Recommended <br />
                                    PNG/SVG is allowed
                                </p>
                                <input
                                    type="file"
                                    id="file-input"
                                    style={{ display: 'none' }}
                                    // onChange={handleFileChange}
                                    accept="image/jpeg, image/jpg, image/png"
                                />
                            </div>
                        </div>
                    </div> */}
          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Name*"
              placeholder="Enter Name"
              value={groupDetails.name}
              onChange={(e) => setGroupDetails((pre) => ({ ...pre, name: e.target.value }))}
            />
          </div>
          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Company Website URL"
              value={groupDetails.website}
              onChange={(e) => setGroupDetails((pre) => ({ ...pre, website: e.target.value }))}
              placeholder="Enter URL"
            />
          </div>
          <div className="col-md-6 mt-3">
            <DropdownSearch
              label="Channel*"
              selectProps={{
                isDisabled: disable,
                options: channelList,
                value: channelList.filter(channel => channel.value === groupDetails.channel),
                onChange: (e) => handleSelectChannel(e),
              }}
            />
          </div>
          <div className="col-md-3 mt-3">
            <SimInputBar
              label="Identifier"
              placeholder="Enter Identifier"
              value={groupDetails.identifier}
              onChange={(e) => setGroupDetails((pre) => ({ ...pre, identifier: e.target.value }))}
            />
          </div>
          <div className="col-md-3 mt-3">
            <DropdownSearch
              label="Industry Type*"
              placeholder="Enter Country"
              selectProps={{
                isMulti: true,
                options: tagsList,
                value: groupDetails?.industry || null,
                onChange: (e) => handleSaveIndustryType("industry", e),
              }}
            />
          </div>
          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Address Line 1"
              placeholder="Enter Address 1"
              value={groupDetails.address.address1}
              onChange={(e) => handleSaveAddress("address1", e.target.value)}
            />
          </div>
          <div className="col-md-6 mt-3">
            <SimInputBar
              label="Address Line 2"
              placeholder="Enter Address 2"
              value={groupDetails.address.address2}
              onChange={(e) => handleSaveAddress("address2", e.target.value)}
            />
          </div>



          <div className="col-md-3 mt-3">
            <DropdownSearch
              label="Country*"
              placeholder="Enter Country"
              selectProps={{
                options: countriesName,
                value: [{ label: groupDetails?.address?.country, value: groupDetails?.address?.country }],
                onChange: (e) => handleSaveAddress("country", e.value),
              }}
            />
          </div>

          <div className="col-md-3 mt-3">
            <DropdownSearch
              label="State*"
              placeholder="Enter State"
              selectProps={{
                options: State.getStatesOfCountry(Country.getAllCountries().find((c) => c.name === groupDetails?.address?.country)?.isoCode || "").map((s) => ({ value: s.name, label: s.name })),
                value: [{ label: groupDetails?.address?.state, value: groupDetails?.address?.state }],
                onChange: (e) => handleSaveAddress("state", e.value),
              }}
            />
          </div>

          <div className="col-md-3 mt-3">
            <SimInputBar
              label="City*"
              placeholder="Enter City"
              value={groupDetails.address.city}
              onChange={(e) => handleSaveAddress("city", e.target.value)}
            />
          </div>

          <div className="col-md-3 mt-3">
            <SimInputBar
              label="Pincode"
              placeholder="Enter Pincode"
              value={groupDetails.address.pincode}
              onChange={(e) => handleSaveAddress("pincode", e.target.value)}
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default CreateGroup;
